import { GetterTree } from "vuex"
import { bannerTextItem, GiftTaskConfigItem, Info } from "../../config"
import { checkTimeValid } from "../../helper"
import { RootState } from ".."
import { AppleGiftCardState } from "./state"

export interface LoginSession {
  openid: string
  openkey: string
  session_id: string
  session_type: string
  wx_appid?: string
}
export interface AppleGiftCardGetters extends GetterTree<AppleGiftCardState, RootState> {
  loginState: (state: AppleGiftCardState) => LoginSession
  banners: (state: AppleGiftCardState) => Info["banners"]
  fullDiscountValid: (state: AppleGiftCardState) => boolean
  fissionActivityValid: (state: AppleGiftCardState) => boolean
  giftTaskConfigItems: (state: AppleGiftCardState) => GiftTaskConfigItem[]
  bannerText: (state: AppleGiftCardState) => bannerTextItem | undefined
}

export interface AppleGiftCardGetterInstance {
  loginState: LoginSession
  banners: Info["banners"]
  giftTaskConfigItems: GiftTaskConfigItem
  fullDiscountValid: boolean
  fissionActivityValid: boolean
  bannerText?: bannerTextItem
  pfSource: string
}

const getters: AppleGiftCardGetters = {
  loginState: state => {
    const session: LoginSession = {
      openid: state.openid,
      openkey: state.openkey,
      session_id: state.sessionId,
      session_type: state.sessionType
    }
    if (state.sessionType == "wc_actoken") {
      session.wx_appid = state.wx_appid
    }
    return session
  },
  banners: state => {
    return state.configInfo.banners.filter(
      banner => !banner?.start_time || !banner?.end_time || checkTimeValid(banner.start_time, banner.end_time)
    )
  },
  giftTaskConfigItems: state => {
    if (!state.activityOfferId) {
      return state.giftTaskConfig.giftTaskConfigItems
        .filter(config => checkTimeValid(config.beginTime, config.endTime))
        .sort((a, b) => b.priority - a.priority)
    }
    return state.giftTaskConfig.giftTaskConfigItems
      .filter(config => checkTimeValid(config.beginTime, config.endTime) && config.offerId === state.activityOfferId)
      .sort((a, b) => b.priority - a.priority)
  },
  // 存在全场折扣
  fullDiscountValid: state =>
    Boolean(state.configInfo?.activityInfo?.group_id) &&
    checkTimeValid(state.configInfo.activityInfo?.start_time, state.configInfo.activityInfo?.end_time),
  fissionActivityValid: state => {
    return (
      Boolean(state.configInfo?.fission?.fissionGroupid) &&
      checkTimeValid(state.configInfo.fission?.begin_time, state.configInfo.fission?.end_time)
    )
  },
  bannerText: state =>
    state.configInfo.bannerTexts?.find(item => item.type === state.usingLocation && checkTimeValid(item.beginTime, item.endTime)),
  pfSource: state => {
    if ((window as any).nowSource) return (window as any).nowSource
    return state.pfSource
  }
}

export default getters
